import React, { useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import apiInstance from "../../shared/utils/axios";
import qrRedirects from "./qrRedirects";

interface QrRedirectPageProps {
  fixedQrId?: string;
}

const QrRedirectPage = ({ fixedQrId }: QrRedirectPageProps) => {
  const { qrId: routeQrId } = useParams();
  const qrId = fixedQrId ?? routeQrId;
  const redirect = qrId ? qrRedirects[qrId] : undefined;
  const redirectStartedRef = useRef(false);

  useEffect(() => {
    if (redirectStartedRef.current) return;

    if (!qrId || !redirect) {
      redirectStartedRef.current = true;
      window.location.replace("https://hereweare.io");
      return;
    }

    if (!redirect.destinationUrl) return;

    redirectStartedRef.current = true;
    const destinationUrl = redirect.destinationUrl;

    const recordAccess = async () => {
      const accessData = {
        qrId,
        destinationUrl,
        destinationContent: redirect.destinationContent,
        magazineIssue: redirect.magazineIssue,
        qrKind: redirect.qrKind,
        userAgent: navigator.userAgent,
        acceptLanguage: navigator.languages.join(",") || navigator.language,
      };

      try {
        await apiInstance.post("/oapi/qr/access", { isMsg: true }, accessData, {
          timeout: 1500,
        });
      } catch {
        // 측정 실패와 무관한 목적지 이동 보장
      } finally {
        window.location.replace(destinationUrl);
      }
    };

    recordAccess();
  }, [qrId, redirect]);

  if (redirect?.destinationUrl) {
    return (
      <main className="flex min-h-screen items-center justify-center">
        <div
          aria-label="Redirecting"
          className="h-6 w-6 animate-spin rounded-full"
          role="status"
          style={{
            borderColor: "#d9ddff",
            borderStyle: "solid",
            borderTopColor: "#6b7eff",
            borderWidth: 2,
          }}
        />
      </main>
    );
  }

  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
      <h1 className="text-xl font-bold">This link is not ready yet.</h1>
      <Link className="underline" to="/">
        Go to HereWeAre
      </Link>
    </main>
  );
};

export default QrRedirectPage;
